import { AuthConfig } from "angular-oauth2-oidc";
import { Environment } from "./env.model";

const clientID = '4novojpshntbgfk5m6jedhat2q';
const issuer = 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_iCZILQmny';

const authCodeFlowConfig: AuthConfig = {
  issuer,

  // tokenEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/token',
  // userinfoEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/userInfo',
  // revocationEndpoint: 'https://id.test.tebiauth.tebis.cloud/oauth2/revoke',

  strictDiscoveryDocumentValidation: false,

  // redirect after login
  redirectUri: 'https://test.tebitask.tebis.cloud/',
  // redirect after logout
  logoutUrl: 'https://test.tebitask.tebis.cloud/',

  clientId: clientID,

  oidc: true,
  responseType: 'code',

  scope: 'openid profile email', // offline_access for refresh token

  showDebugInformation: true,
};

export const environment: Environment = {
    name : "Test - Copy of prod 6.8.25",
    baseUrl: '',
    baseUrlRds: 'https://api.test.tebitask.tebis.cloud/api',
    clientID,
    issuer,
    authCodeFlowConfig,
    clientIDSourceUrl: 'https://api.test.tebiauth.tebis.cloud/clientids/tebitask',
};
